import React from 'react';

import Navigation from './Navigation';
import './styles.scss';

const App = () => {
  return (
    <div className="AppMainContainer">
      <Navigation />
    </div>
  );
};

export default App;
